import { ethers } from 'ethers';
import type { DocumentNode } from 'graphql';
import type { FC } from 'react';
import { useEffect, useState } from 'react';

import { PRICE_FILTER_MAX } from '../../constants/marketplace';
import { useInfiniteScroll } from '../../hooks/infinite-scroll.hooks';
import { useExcludedAssetsIds } from '../../hooks/marketplace-list.hook';
import type { Asset } from '../../lib/graph/MogulMarketplace';
import assetCollectionActiveListQuery from '../../lib/graph/queries/assetCollectionActiveListQuery';
import assetCollectionActiveListSortByQuery from '../../lib/graph/queries/assetCollectionActiveListSortByQuery';
import assetCollectionListQuery from '../../lib/graph/queries/assetCollectionListQuery';
import assetListPriceQuery from '../../lib/graph/queries/assetListPriceQuery';
import type { searchOptions } from '../search-bar/searchOptions/SearchOptions.component';
import { MarketplaceComponent } from './Marketplace.component';

interface MarketplaceProps {
  gql: DocumentNode;
  gql2: DocumentNode;
  search: string;
  options: searchOptions | undefined;
  nftContractAddress?: string | null;
  network?: string;
}

export const MarketplaceListComponent: FC<MarketplaceProps> = ({
  gql,
  gql2,
  nftContractAddress,
  search,
  options,
  network,
}) => {
  const [_, setDelaySearch] = useState('');
  const [first, __] = useState(20);
  const [minPriceDelay, setMinPriceDelay] = useState('0');
  const [maxPriceDelay, setMaxPriceDelay] = useState(PRICE_FILTER_MAX);

  const excludedAssetsIds = useExcludedAssetsIds(nftContractAddress);

  const {
    loading,
    fetchedData: allFetchedData,
    loader,
  } = useInfiniteScroll<{
    assets: Asset[];
  }>(
    ((options?.range?.minVal !== '' || options.range.maxVal !== '') &&
      assetListPriceQuery) ||
      (options?.listingType && assetCollectionActiveListQuery) ||
      (options?.sortBy === 'mintedTime' &&
        assetCollectionActiveListSortByQuery) ||
      (options?.sortBy === 'displayPrice' && assetCollectionActiveListQuery) ||
      assetCollectionListQuery,
    {
      assets: [],
    },
    curr => prev => ({
      assets: [...prev.assets, ...curr.assets],
    }),
    d => !d.assets.length,
    {
      variables: {
        // delaySearch,
        orderBy: options?.sortBy,
        orderDirection: options?.sortDirection,
        first,
        nftContractAddress,
        minPriceDelay,
        maxPriceDelay,
        excludedAssetsIds: excludedAssetsIds?.length
          ? excludedAssetsIds
          : undefined,
      },
      skip: excludedAssetsIds === null,
    },
    undefined,
    network,
  );

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDelaySearch(search);
      setMinPriceDelay(
        options?.range?.minVal !== undefined && options.range.minVal !== ''
          ? ethers.utils.parseEther(options.range.minVal).toString()
          : '0',
      );
      setMaxPriceDelay(
        options?.range?.maxVal !== undefined && options.range.maxVal !== ''
          ? ethers.utils.parseEther(options.range.maxVal).toString()
          : PRICE_FILTER_MAX,
      );
    }, 200);
    return () => clearTimeout(timeoutId);
  }, [search, options]);

  const listedAssets = allFetchedData.assets.filter(
    asset => asset.activeListings?.length,
  );
  const restAssets = allFetchedData.assets.filter(
    asset => !(asset.activeListings ?? []).length,
  );

  const assets = listedAssets.concat(restAssets);

  return (
    <>
      <div className="flex lg:flex-row flex-col justify-between mt-8 mb-4 ">
        <div className="fontVanguard font-bold xl:text-4xl text-3xl leading-7 lg:mb-0 mb-2 sm:ml-0 ml-5">
          {search.length > 0
            ? `Displaying Results For:    ${search}`
            : nftContractAddress == null
            ? 'All Items'
            : 'Collection Items'}
        </div>
      </div>
      <MarketplaceComponent
        assets={
          // !options?.listingType
          // ? assets
          assets
          // : assets.filter(
          //     asset =>
          //       asset.activeListings?.filter(
          //         listing => listing.type === options.listingType,
          //       ).length,
          //   )
        }
        showViewCollection={false}
      />
      {!loading && (
        <div
          ref={loader}
          className={'w-full ' + (nftContractAddress != null ? 'h-72' : 'h-44')}
        ></div>
      )}
    </>
  );
};
